// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}


	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body')
	//const dropDownMenu   = document.getElementById('js-site-menu')

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close')
			menuOpenTarget.classList.toggle('is-menu-open')
			//dropDownMenu.classList.toggle('is-active')
		} );
	}



	// Pagetop Visible
	// --------------------------------------------------------------- //

	function pagetopVisible() {
		const pagetop = document.getElementById('js-pagetop')
		let offset = window.pageYOffset
		let docHeight = document.body.scrollHeight
		let posMulti = .4

		if ( offset > (docHeight * posMulti) ) {
			pagetop.classList.add('is-visible')
		} else {
			pagetop.classList.remove('is-visible')
		}
	}

	window.onscroll = function(e) {
		pagetopVisible();
	}
//	window.onresize = function(e) {
//		pagetopVisible();
//	}



	// Accordion
	// --------------------------------------------------------------- //

	function initAccordion(elem, option){
		//addEventListener on mouse click
		document.addEventListener('click', function (e) {
			//check is the right element clicked
			if ( !e.target.matches(elem+' .js-accordion-button') ) return;
			else{
				//check if element contains active class
				if ( !e.target.parentElement.classList.contains('is-active') ) {
					if ( option == true ) {
						 //if option true remove active class from all other accordions
						var elementList = document.querySelectorAll(elem +' .js-accordion-container');
						Array.prototype.forEach.call(elementList, function (e) {
							e.classList.remove('is-active');
						});
					}
					//add active class on cliked accordion
					e.target.parentElement.classList.add('is-active');
				} else {
					//remove active class on cliked accordion
					e.target.parentElement.classList.remove('is-active');
				}
			}
		});
	}

	initAccordion('.js-accordion', true);



	// 見学会フォームの hidden 入れ込み
	// --------------------------------------------------------------- //

	const mwFormId = document.getElementById('mw_wp_form_mw-wp-form-359')

	if ( mwFormId ) {
		let url = location.href
		let hiddenName = document.getElementsByName('page-url')

		if ( hiddenName ) {
			hiddenName[0].value = url
		}

	}



	// [plugin] Swiper
	// --------------------------------------------------------------- //

	let swiperWorksflag = document.getElementById('js-works-swiper');

	let worksSwiper;

	const breakpointChecker = function() {
		if ( breakpoint.matches === false ) {
			return enableSwiper();
		} else if ( breakpoint.matches === true ) {
			if ( worksSwiper !== undefined ) worksSwiper.destroy( true, true );
			return;
		}
	};

	const enableSwiper = function() {
		worksSwiper = new Swiper ('#js-works-swiper', {
			loop: true,
			slidesPerView: 1.2,
			spaceBetween: 16,
			centeredSlides : true,

			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		} );
	};

	if ( swiperWorksflag ) {
		breakpoint.addListener(breakpointChecker);

		breakpointChecker();
	}

//	let worksSwiper = new Swiper ('#js-works-swiper', {
//		loop: true,
//		slidesPerView: 1.2,
//		spaceBetween: 16,
//		centeredSlides : true,
//		breakpoints: {
//		960: {
//				slidesPerView: 1.25,
//				spaceBetween: 16,
//			}
//		},
//
//		pagination: {
//			el: ".swiper-pagination",
//			clickable: true,
//		},
//	} );



	// TOP Gallery Link
	// --------------------------------------------------------------- //

	const galleryTarget = document.querySelectorAll('.wp-block-gallery.is-front-plan');

	for ( let i = 0; i < galleryTarget.length; i++) {
		galleryTarget[i].addEventListener('click', function(event) {
			window.location.href = '/plan';
		});
	}




	// [plugin] lightGallery
	// --------------------------------------------------------------- //

	let gallery = document.querySelectorAll('.js-gallery');

	for ( let i = 0; i < gallery.length; i++ ) {
		lightGallery( gallery[i], {
			selector: '.js-gallery-item'
		});
	}

	let wpGallery = document.querySelectorAll('.js-wp-gallery');

	for ( let i = 0; i < wpGallery.length; i++ ) {
		lightGallery( wpGallery[i], {
			selector: '.blocks-gallery-item a'
		});
	}


	// [plugin] flatpickr
	// --------------------------------------------------------------- //

	const flatpickrDateConfig = {
		'locale': 'ja',
		minDate: 'today',
		dateFormat: "Y/m/d",
		//disableMobile: "true"
	}
	flatpickr('#js-date', flatpickrDateConfig);

	const flatpickrTimeConfig = {
		'locale': 'ja',
		enableTime: true,
		noCalendar: true,
		dateFormat: "H:i",
		time_24hr: true,
		//disableMobile: "true"
	}
	flatpickr('#js-time', flatpickrTimeConfig);


} );

